<template>
  <div id="app">
    <ThemeToggler />
    <router-view />
  </div>
</template>

<script>
import ThemeToggler from '@/components/ThemeToggler'

export default {
  name: 'App',
  components: {
    ThemeToggler
  }
}
</script>

<style>
@font-face {
  font-family: 'Roboto Slab', serif;
  src: url('https://fonts.googleapis.com/css?family=Roboto+Slab&display=swap');
}

:root {
  color-scheme: light dark;
  --font-color: black;
  --bg-color: white;
  --td-border-color: #ddd;
  --tr-hover-color: #f5f5f5;
}

/*
@media (prefers-color-scheme: dark) {
  .app  { background:  black; color: white; }
}

@media (prefers-color-scheme: light) {
  .app  { background:  white; color: black; }
}
*/

body {
  font-family: 'Roboto Slab', serif;
  background: var(--bg-color);
  color: var(--font-color);
}

button {
  border: 1px solid;
  background-color: inherit;
  cursor: pointer;
  margin: 2px;
  color: var(--font-color);
}

button:hover {
  box-shadow: 2px 2px rgba(0, 0, 0, 0.2);
}
</style>
